import { render, staticRenderFns } from "./FormCheckboxGroup.vue?vue&type=template&id=2d9663a0&scoped=true&"
import script from "./FormCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./FormCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormCheckboxGroup.vue?vue&type=style&index=0&id=2d9663a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9663a0",
  null
  
)

export default component.exports